import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["gh-button ellipsis", [_ctx.size, _ctx.type]]),
    style: _normalizeStyle({ color: _ctx.color })
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 6))
}